import type { SVGProps } from 'react';
import * as React from 'react';

const ChevronUpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="outline/chevron-up">
      <path
        id="Icon"
        d="M5 15.1001L12 8.1001L19 15.1001"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default ChevronUpIcon;
